import { BaseDialog } from "@/lib/Components/Dialog/BaseDialog";
import { GenericForm } from "@/lib/Components/Form/Forms/GenericForm";
import {
  PurchasableExtraListResult,
  updateSupplierPurchasableExtraMutation,
} from "@/app/Suppliers/GraphQL/supplierPurchasableExtrasQuery";
import { useDialogState } from "@/lib/Components/Dialog/Hooks/useDialogState";
import { Currency, UpdateSupplierPurchasableExtraInput } from "@/gql/graphql";
import { useGqlMutation } from "@/lib/GraphQLCodegen/fetcher";
import { SupplierPurchasableExtraForm } from "@/app/Suppliers/Components/SupplierPurchasableExtraCreateDialog";
import { DialogSubmitButton } from "@/lib/Components/Dialog/Components/DialogSubmitButton";
import { SupplierPurchasableExtraImagePanel } from "@/app/Suppliers/Components/SupplierPurchasableExtraImagePanel";

export function SupplierPurchasableExtraUpdateDialog({
  supplierPurchasableExtra,
  currency,
}: {
  supplierPurchasableExtra: PurchasableExtraListResult;
  currency: Currency;
}) {
  const { close } = useDialogState();
  const { mutateAsync } = useGqlMutation(
    updateSupplierPurchasableExtraMutation,
  );

  return (
    <BaseDialog title={`Update ${supplierPurchasableExtra.name}`}>
      <GenericForm<UpdateSupplierPurchasableExtraInput>
        initialValues={{
          name: supplierPurchasableExtra.name,
          description: supplierPurchasableExtra.description,
          units_purchasable: supplierPurchasableExtra.units_purchasable,
          unit_price: supplierPurchasableExtra.unit_price,
        }}
        onSubmit={async (values) => {
          await mutateAsync({
            id: supplierPurchasableExtra.id,
            input: values,
          });
          close();
        }}
      >
        <SupplierPurchasableExtraForm currency={currency} />
        <SupplierPurchasableExtraImagePanel
          extraId={supplierPurchasableExtra.id}
        />
        <DialogSubmitButton text={`Update purchasable extra`} />
      </GenericForm>
    </BaseDialog>
  );
}
